import {
    Object3D,
    BoxBufferGeometry,
    Mesh, Box3, Vector3,
    Euler
} from 'three';
import { component } from 'bidello';
import * as THREE from 'three';
import TWEEN from 'three/examples/jsm/libs/tween.module.min';


export class Telescope extends component(Object3D) {

    init(){

        this.originalRotation = new Euler ();
        this.renderOrder = 2
        this.meshModelSource = null;
        this.meshModel = null;
        this.renderOrder = 0


    }


    attachMesh(mesh){

        mesh.parent = this;
        this.meshModel = mesh;
        this.meshModel.material.transparent = false
        this.add(this.meshModel)
        this.originalRotation = this.rotation;
        this.defaultStateTween = new TWEEN.Tween(this.meshModel.rotation)
            .to({x:this.originalRotation.x,y:this.originalRotation.y,z:this.originalRotation.z},1000)
            .onUpdate(()=>{console.log("update")})
            .easing(TWEEN.Easing.Exponential.InOut);


    }


    getCenter(){

        const box = new Box3().setFromObject(this.meshModel);
        return box.getCenter(new Vector3());

    }

    getSizeBox (){

        const box = new Box3().setFromObject(this.meshModel);
        return  box.getSize(new Vector3()).length();

    }


    setMinimalState (){

        this.meshModel.rotation.set(
            0.1,
            4.2,
            5.2
        )
    }

    setDefaultState (){


    }


}



